/**
 * Gourmet Mallorca: Kaufbutton und eigener Warenkorb-Drawer verbinden
 *
 * Problem: Der Horizon-Kaufbutton meldet ein hinzugefügtes Produkt mit dem
 * Signal "cart:update". Der eigene Drawer (sections/cart-drawer.liquid)
 * hört aber nur auf "cart:refresh". Ergebnis: Häkchen am Button, aber
 * Drawer und Zahl am Warenkorb-Symbol bleiben stehen.
 *
 * Lösung: Bei "cart:update" den Drawer neu laden und öffnen.
 * Auf der Warenkorbseite (/cart) wird nur neu geladen, nicht geöffnet.
 * Das Geschenk-Skript (gm-gift.js) sendet "cart:refresh", "cart:updated"
 * und "cart:change", aber nicht "cart:update" — keine Wechselwirkung.
 */
(function () {
  var busy = false;

  document.addEventListener('cart:update', function () {
    if (busy) return;
    busy = true;

    try {
      if (typeof window.gmDrawerRefresh === 'function') window.gmDrawerRefresh();
    } catch (e) {}

    var onCartPage = /\/cart(\/|$)/.test(window.location.pathname);
    if (!onCartPage) {
      try {
        if (typeof window.gmDrawerOpen === 'function') window.gmDrawerOpen();
      } catch (e) {}
    }

    setTimeout(function () { busy = false; }, 400);
  });
})();